module.exports = __webpack_public_path__ + "assets/commentQuestion.8d29c6e9.svg";